import SwiperCore, { Pagination, Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import Image from 'next/image'

import useBreakpoint from 'hooks/useBreakPoint'
import styles from './index.module.scss'
import { AwardsByType } from '../constants'

SwiperCore.use([Pagination, Navigation])

const AwardPanel: React.FC<AwardPanelProps> = ({ type }) => {
  const { isMobileScreen } = useBreakpoint()

  return (
    <div className={styles.awardPanel}>
      <div className={styles.awardPanel__heading}>
        <div className={styles.awardPanel__heading__imageWrapper}>
          <img
            src="/images/award-panel-award.svg"
            width={47}
            height={65}
            alt="Award logo"
          />
        </div>
        <div className={styles.awardPanel__headingText}>
          Award-winning therapy
        </div>
      </div>
      <div className={styles.awardPanel__wrapper}>
        <Swiper
          key={isMobileScreen ? 'mobileAwardPanel' : 'desktopAwardPanel'}
          slidesPerView={isMobileScreen ? 1 : 2}
          allowSlideNext={isMobileScreen}
          allowSlidePrev={isMobileScreen}
          allowTouchMove={isMobileScreen}
          pagination={{
            clickable: false,
            bulletClass: 'award-panel-carousel-custom-pagination-bullet',
          }}
          observer
          className="award-panel-carousel-wrapper"
        >
          {AwardsByType[type].map((award) => (
            <SwiperSlide key={award}>
              <div className={styles.awardPanel__container}>
                <Image src={award} height={92} width={394} alt="Award" />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  )
}

export default AwardPanel
